<template>
  <div class="log-list">
    <el-form :inline="true" class="demo-form-inline" v-loading="loading" size="mini">
      <!--<el-form-item>-->
        <!--<el-input v-model="search" placeholder="输入模块名查询" size="small"></el-input>-->
      <!--</el-form-item>-->
     
      <el-form-item label="开始时间">
        <el-date-picker
                v-model="search.startDate"
                type="datetime"
                placeholder="选择日期时间"
                align="center"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="结束时间">
        <el-date-picker
                v-model="search.endDate"
                type="datetime"
                placeholder="选择日期时间"
                align="center"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="fetch" size="mini">查询</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="list" size="mini">
      <el-table-column prop="c" label="元">
        <template slot-scope="scope">
          {{scope.row.c/100}}
        </template>
      </el-table-column>
      <el-table-column prop="d" label="时间"></el-table-column>


    </el-table>
    <br/>
    <div style="float: right">
      <el-pagination
              background
              layout="prev, pager, next"
              @current-change="i=>page=i"
              :page-size="20"
              :page-count="page"
              :total="total">
      </el-pagination>
    </div>

  </div>
</template>

<script>

  import api from '../api'
  const {data} = api
  import moment from 'moment'


  export default {
    name: "log-list",
    data() {
      return {
        loading: true,
        list: [],
        roles:[],
        total:0,
        page:1,
        search:{
          startDate:'',
          endDate:''
        }
      };
    },
    watch:{
      page(){
        this.fetch()
      }
    },
    methods: {
      async fetch() {
        this.loading = true;

        let pageNum = this.page
        let {startDate,endDate} = this.search
        if(startDate){
          startDate = moment(startDate).format('YYYYMMDD')
        }
        if(endDate){
          endDate = moment(endDate).format('YYYYMMDD')

        }
        let obj = {start:(pageNum-1)*20,startDate,endDate}

        let res = await data.income(obj);
        //
        // this.total = res.data.pageinfo.totalCount
        this.list = res.data.data ;
        this.loading = false;
      },
    },
    mounted() {
      this.fetch();
    }
  };
</script>

<style>
  .user-list {
  }
</style>



// WEBPACK FOOTER //
// src/views/data/income-list.vue